import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useLoadDataByLocation({ setData, locationKey }) {
  const location = useLocation();

  useEffect(() => {
    if (location) {
      if (location.state.data) {
        setData(location.state.data);
      } else if (location.state.customData) {
        setData(location.state.customData);
      }
    }
  }, [location]);

  return {
    [locationKey]: location.state[locationKey],
    data: location.state?.data || location.state?.customData,
  };
}
